import { ObservableFromFetch } from "../ObservableFromFetch"

export default function OrderCancel(testDetailID?: string, testDetailClinicalID?: string, formFoxTestAN?: string) {
  const requestBody: string = JSON.stringify({
    MockTestDetailID: testDetailID,
    MockTestDetailClinicalID: testDetailClinicalID,
    FormFoxTestAN: formFoxTestAN
  })

  return ObservableFromFetch<string>("WorkforceOrder/CancelOrder", requestBody)
}